import httpService from "..";

/**
 * Get group-level statement data including all payments and member summaries
 * @param groupId - The group ID
 * @param startDate - Start date for the statement period
 * @param endDate - End date for the statement period
 */
export const getGroupStatementApi = async (
  groupId: string,
  startDate: string,
  endDate: string
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/${groupId}/statement?startDate=${startDate}&endDate=${endDate}`,
    "get"
  );
};

/**
 * Get all payments for a specific group
 * @param groupId - The group ID
 * @param startDate - Optional start date filter
 * @param endDate - Optional end date filter
 */
export const getGroupPaymentsApi = async (
  groupId: string,
  startDate?: string,
  endDate?: string
) => {
  const params = startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : '';
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/${groupId}/payments${params}`,
    "get"
  );
};

/**
 * Get group payment summary statistics
 * @param groupId - The group ID
 * @param startDate - Optional start date filter
 * @param endDate - Optional end date filter
 */
export const getGroupPaymentSummaryApi = async (
  groupId: string,
  startDate?: string,
  endDate?: string
) => {
  const params = startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : '';
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/${groupId}/payments/summary${params}`,
    "get"
  );
};

/**
 * Get member payment breakdown for a group
 * @param groupId - The group ID
 * @param startDate - Optional start date filter
 * @param endDate - Optional end date filter
 */
export const getGroupMemberBreakdownApi = async (
  groupId: string,
  startDate?: string,
  endDate?: string
) => {
  const params = startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : '';
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/${groupId}/members/breakdown${params}`,
    "get"
  );
};

export default {
  getGroupStatementApi,
  getGroupPaymentsApi,
  getGroupPaymentSummaryApi,
  getGroupMemberBreakdownApi,
};
